import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Cursor02 = function Cursor02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M20.5056 10.7754c.6169-.2399.9254-.3599 1.012-.5295a.5.5 0 0 0-.0061-.4664c-.091-.1672-.4025-.279-1.0255-.5027L4.5963 3.5728c-.5097-.183-.7646-.2744-.9312-.2167a.5.5 0 0 0-.3088.3088c-.0577.1666.0338.4215.2167.9312l5.704 15.8897c.2236.623.3355.9345.5027 1.0255a.5.5 0 0 0 .4664.0061c.1696-.0866.2895-.3951.5295-1.012l2.5968-6.6776c.047-.1208.0705-.1812.1068-.2321a.5.5 0 0 1 .1167-.1167c.0509-.0363.1113-.0598.2321-.1068z"
    })
  }));
};
export default Cursor02;